'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { Helmet } from 'react-helmet-async';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';

// Lazy load WebDevelopment component with reserved space
const WebDevelopment = dynamic(
  () => import('../../../components/Services/CustomAPIDev'),
  {
    ssr: true,
    loading: () => <div style={{ minHeight: '400px' }}>Loading Custom API Development details...</div>, // Placeholder for WebDevelopment
  }
);

export default function ServicePage() {
  return (
    <>
      <Helmet>
        <title>Custom API Development - Data Pulse Technologies</title>
        <meta
          name="keywords"
          content="custom API development, API integration, API developers, API development company, RESTful APIs, GraphQL APIs, third-party integrations, API documentation, API security"
        />
        <meta
          name="description"
          content="Data Pulse Technologies offers custom API development services, supporting REST, SOAP, XML, and RPC protocols. Our experienced developers create seamless API integrations, build scalable RESTful and GraphQL APIs, and provide comprehensive documentation and security measures for optimal performance."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Data Pulse Technologies",
            "url": "https://www.datapulsetechnologies.org",
            "logo": "https://www.datapulsetechnologies.org/Logo_Main.webp",
            "description":
              "Data Pulse Technologies offers comprehensive custom API development services, building scalable and secure APIs for seamless integration with various platforms and applications.",
            "sameAs": [
              "https://www.linkedin.com/company/data-pulse-technologies/",
              "https://www.instagram.com/datapulsetechnologies/",
              "https://www.facebook.com/people/Data-Pulse-technologies/61556207078422/",
            ],
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "+353852006837",
                "contactType": "Customer Service",
                "areaServed": "Global",
                "availableLanguage": "English",
              },
            ],
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "317 Blarney Golf Resort, Tower",
              "addressLocality": "Co. Cork",
              "postalCode": "T23RK05",
              "addressCountry": "Ireland",
            },
            "department": {
              "@type": "Department",
              "name": "Custom API Development",
              "description":
                "We specialize in building secure, scalable, and high-performing APIs using REST, SOAP, and GraphQL protocols for seamless integration and functionality.",
            },
          })}
        </script>
      </Helmet>
      <div>
        {/* Preload critical assets */}
        <link rel="preload" href="https://www.datapulsetechnologies.org/Logo_Main.webp" as="image" />

        {/* Render Navbar immediately */}
        <Navbar />

        {/* Lazy load WebDevelopment with placeholder */}
        <WebDevelopment />

        {/* Render Footer */}
        <Footer />
      </div>
    </>
  );
}
